import Loadable from 'react/components/loadable';

const InvoicePlanMembershipsRealignment = Loadable({
  loader: () =>
    import(
      '../../../pages/contacts/memberships/invoice_plan_memberships/invoice_plan_membership_realignments'
    ),
});

angular.module('gym').value('InvoicePlanMembershipsRealignment', InvoicePlanMembershipsRealignment);
